module.exports = __webpack_public_path__ + "media/img/logo-transparent-lg-dark-41d6000a265071376d8e3439206a08c0.png";